import { DEFAULT_FILTERS, TESTS_PAGE_STATUSES, TIME_INTERVAL_OPTIONS } from './constants';
import { getUnixTimestampInSeconds } from './ducks/filterBar/utils';
import { getStartEndDate, prepareOwnersQuery } from './util';

// map filters keys to query params
const mapFromFilterKeys = {
  builds: 'build',
  oses: 'os',
  browsers: 'browser',
  tags: 'tag',
  owners: prepareOwnersQuery,
};

// map payload keys to filter keys
const mapToFilterKeys = (
  Object
    .entries(mapFromFilterKeys)
    .reduce((acc, [key, value]) => {
      acc[value] = key;
      return acc;
    }, {})
);

// Reduce `filters` (a nested Immutable.Map) to { [key]: [value1, value2, ...] }.
// The result is safe to pass as query params to axios.
export const getFilterParamsAdapter = (
  filters,
  mapping = mapFromFilterKeys,
  defaultFilters = DEFAULT_FILTERS,
) => (
  filters.reduce((acc, value, key) => {
    if (!value.get('selectedItems').size) {
      return acc;
    }

    const newKey = key in mapping ? mapping[key] : key;

    if (typeof newKey === 'function') {
      return { ...acc, ...newKey(value.get('selectedItems').toJS()) };
    }

    acc[newKey] = value.get('selectedItems').toJS();
    return acc;
  }, { ...defaultFilters })
);

// Replace playload aggregations keys to match filter keys.
export const getFilterPayloadAdapter = (data, mapping = mapToFilterKeys) => (
  Object
    .entries(data)
    .reduce((acc, [key, value]) => {
      const newKey = key in mapping ? mapping[key] : key;
      acc[newKey] = value;
      return acc;
    }, {})
);

/**
 * Collect time filter params.
 * @param {Map} dateFilter
 * @param {string} dateFilter.type
 * @param {number} dateFilter.value
 */
export const getTimeFilterParams = (dateFilter, base = Date.now(), priorData = false) => {
  const { startDate, endDate } = getStartEndDate(dateFilter, base, priorData);
  return {
    start: getUnixTimestampInSeconds(startDate),
    since: getUnixTimestampInSeconds(startDate),
    end: getUnixTimestampInSeconds(endDate),
    until: getUnixTimestampInSeconds(endDate),
  };
};

/**
 * Collect pagination params.
 * @param {Map} pagination
 * @return {Object}
 */
export const getPaginationV2Params = (pagination) => {
  const limit = pagination.get('size');
  const current = pagination.get('current') - 1;
  return {
    limit,
    offset: current * limit,
  };
};

/**
 * Prepare status query params
 * @param {String} status
 * @return {Object}
 */
export const getStatusParams = (status) => {
  if (!status) {
    return null;
  }

  if (status === TESTS_PAGE_STATUSES.inconsistent.status) {
    return { mixed_status: true };
  }

  return {
    status: TESTS_PAGE_STATUSES[status].statusV2 || status,
  };
};

/**
 * Collect time-range params according to selected bar.
 * @param {Map} trends
 * @return {Object}
 */
export const getBarSelectionParams = (trends) => {
  const selectedBar = trends.get('selectedBar');
  const interval = trends.get('interval');
  if (!selectedBar) {
    return null;
  }

  return {
    start: selectedBar.timestamp_ms / 1000,
    end: (selectedBar.timestamp_ms + TIME_INTERVAL_OPTIONS[interval].timeMS) / 1000,
  };
};
